import React, { useState } from "react";
import "./Gallery.css";
import ImageSlider from "./ImageSlider";

// Deck images data
const deckImages = [
  {
    before: process.env.PUBLIC_URL + "/work/deck/deck1_before.jpg",
    after: process.env.PUBLIC_URL + "/work/deck/deck1_after.jpg",
    title: "Deck Transformation - View 1",
  },
  {
    before: process.env.PUBLIC_URL + "/work/deck/deck2_before.jpg",
    after: process.env.PUBLIC_URL + "/work/deck/deck2_after.jpg",
    title: "Deck Transformation - View 2",
  },
  {
    before: process.env.PUBLIC_URL + "/work/deck/deck3_before.jpg",
    after: process.env.PUBLIC_URL + "/work/deck/deck3_after.jpg",
    title: "Deck Transformation - View 3",
  },
  {
    before: process.env.PUBLIC_URL + "/work/deck/deck4_before.jpg",
    after: process.env.PUBLIC_URL + "/work/deck/deck4_after.jpg",
    title: "Deck Transformation - View 4",
  },
];

// Door images data
const doorImages = [
  {
    before: process.env.PUBLIC_URL + "/work/door-before.jpg",
    after: process.env.PUBLIC_URL + "/work/door-after.jpg",
    title: "Entry Door for Veteran's Home",
  },
];

const images = [
  {
    src: process.env.PUBLIC_URL + "/work/VBS-house.jpg",
    alt: "VBS House",
    description:
      "We're proud to support our community! Steadfast Exteriors & General Contracting recently built and donated this custom log cabin-style prop for a local church's Vacation Bible School (VBS) program.",
  },
  {
    src: process.env.PUBLIC_URL + "/work/barn-roof.jpg",
    alt: "Barn Roof",
    description:
      "We recently completed a gutter installation on this barn to help protect the structure from water damage and improve drainage around the foundation. The new system ensures better runoff control and adds a clean, finished look to the exterior.",
  },
  {
    src: process.env.PUBLIC_URL + "/work/door-after.jpg",
    alt: "Entry Door for Veteran's Home",
    description: "slider",
    isSlider: true,
    sliderType: "door",
  },
  {
    src: process.env.PUBLIC_URL + "/work/deck/deck1_after.jpg",
    alt: "Deck Transformation Project",
    description: "slider",
    isSlider: true,
    sliderType: "deck",
  },
];

const Gallery = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [sliderOpen, setSliderOpen] = useState(false);
  const [selectedSliderType, setSelectedSliderType] = useState("");

  const openModal = (index) => {
    if (images[index].isSlider) {
      setSelectedSliderType(images[index].sliderType);
      setSliderOpen(true);
    } else {
      setSelectedIndex(index);
      setModalOpen(true);
    }
  };

  return (
    <div className="gallery-container">
      <h2 className="gallery-title">Project Gallery</h2>
      <p className="gallery-description">
        Click on an image to see a description
      </p>
      <div className="gallery-grid">
        {images.map((img, idx) => (
          <img
            key={img.src}
            src={img.src}
            alt={img.alt}
            className="gallery-image"
            onClick={() => openModal(idx)}
            style={{ cursor: "pointer" }}
          />
        ))}
      </div>

      {/* Regular Modal */}
      {modalOpen && (
        <div
          className="gallery-modal-overlay"
          onClick={() => setModalOpen(false)}
        >
          <div className="gallery-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <h2 className="modal-title">{images[selectedIndex].alt}</h2>
              <p className="modal-description">
                {images[selectedIndex].description}
              </p>
              <div className="modal-image-container">
                <img
                  src={images[selectedIndex].src}
                  alt={images[selectedIndex].alt}
                  className="modal-image"
                />
              </div>
            </div>
            <button
              className="gallery-modal-close"
              onClick={() => setModalOpen(false)}
            >
              &times;
            </button>
          </div>
        </div>
      )}

      {/* Slider Modal */}
      {sliderOpen && (
        <div
          className="gallery-modal-overlay"
          onClick={() => setSliderOpen(false)}
        >
          <div className="slider-modal" onClick={(e) => e.stopPropagation()}>
            {selectedSliderType === "door" ? (
              <ImageSlider
                images={doorImages}
                title="Entry Door for Veteran's Home"
                description="We had the honor of installing a new entry door for a Veteran's widow, helping improve both security and comfort in her home. It's always a privilege to give back to those who've served — Go Navy!"
              />
            ) : (
              <ImageSlider
                images={deckImages}
                title="Deck Transformation Project"
                description="What was once a dated, worn-out patio has been completely transformed into a sleek, modern deck with clean lines and sturdy construction."
              />
            )}
            <button
              className="gallery-modal-close"
              onClick={() => setSliderOpen(false)}
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
